import { twMerge } from 'tailwind-merge';
import ToggleButton, {
  type ToggleButtonProps,
} from '@mui/material/ToggleButton';
import Tooltip, { type TooltipProps } from '@/components/Tooltip';
import { classes, styles } from './utils';

export interface ToggleOptionProps extends ToggleButtonProps {
  tooltip?: string;
  tooltipPlacement?: TooltipProps['placement'];
}

export default function ToggleOption({
  className,
  sx = {},
  tooltip,
  tooltipPlacement,
  children,
  ...props
}: ToggleOptionProps) {
  return (
    <ToggleButton
      sx={{ ...styles.toggleButton, ...sx }}
      className={twMerge(classes.toggleButton, className)}
      {...props}>
      {tooltip ? (
        <Tooltip arrow title={tooltip} placement={tooltipPlacement}>
          {<>{children}</>}
        </Tooltip>
      ) : (
        children
      )}
    </ToggleButton>
  );
}
